export function processHeader(data) {
  const headerData = data?.aepheader;


  let backgroundimage, navigation, notification, profile, logo,mobilelogo, logoLink;

  if (data) {
    backgroundimage = headerData?.bgimage?.results[0]?.fileUrl;
    navigation = headerData?.navigation?.results;
    notification = headerData?.notification?.results;
    profile = headerData?.profile?.results;
    logo = headerData?.logo?.results;
    mobilelogo = headerData?.mobilelogo?.results;
    logoLink = headerData?.hyperlink;
  }
  return {
    backgroundimage,
    navigation,
    notification,
    profile,
    logo,
    mobilelogo,
    logoLink
  };
}

export function processFooter(data) {
  let key;
  if (data) {
    key = Object.keys(data);
  }

  const footerData = data?.aepfooter;

  const desc = footerData?.description?.content[0]?.content[0]?.text;
  const logo = footerData?.logo?.results[0]?.fileUrl;
  const links = footerData?.links?.results;
  const sublinks = footerData?.sublinks?.results;
  const copyright = footerData?.copyright;

  const appleStoreData = footerData?.appStore?.results[0];
  const googlePlayStoreData = footerData?.googlePlay?.results[0];

  const appleStoreLink = appleStoreData?.hyperlink;
  const googlePlayLink = googlePlayStoreData?.hyperlink;
  const appleStoreIcon = appleStoreData?.icon?.results[0]?.fileUrl;
  const googlePlayIcon = googlePlayStoreData?.icon?.results[0]?.fileUrl;

  return {
    desc,
    logo,
    links,
    sublinks,
    copyright,
    appleStoreLink,
    googlePlayLink,
    appleStoreIcon,
    googlePlayIcon
  };
}

export function processPrivacyPolicyData(data) {
  const aepprivacytermsData = data?.aepprivacytermspage;
  const title = aepprivacytermsData?.contentarticle?.results[0]?.title;
  const desc =
    aepprivacytermsData?.contentarticle?.results[0]?.description?.content[0]
      ?.content[0]?.text;

  return {
    title,
    desc,
  };
}

export function processTermsAndConditionData(data) {
  const aepprivacytermsData = data?.aepprivacytermspage;
  const title = aepprivacytermsData?.contentarticle?.results[0]?.title;
  const desc =
    aepprivacytermsData?.contentarticle?.results[0]?.description?.content[0]
      ?.content[0]?.text;

  return {
    title,
    desc,
  };
}

export function processParentThankyouData(data) {
  const thankyouData = data?.data?.aepthankyoupage;
  const title = thankyouData?.contentarticle.results[0].title;
  const description =
    thankyouData?.contentarticle.results[0]?.description.content[0].content[0]
      .text;
  const thanksImg =
    thankyouData.contentarticle.results[0].relatedmedia.results[0].fileUrl;
  const exploreMore = thankyouData.links.results[0].name;
  const exploreMoreLink = thankyouData.links.results[0].hyperlink;
  const externallink = thankyouData.links.results[0].externallink;

  return {
    title,
    description,
    thanksImg,
    exploreMore,
    exploreMoreLink,
    externallink,
  };
}

export function processParentFAQData(data) {
  const faqData = data?.data?.aepfaqpage;
  const title = faqData?.contentarticle?.results[0]?.title;
  const description =
    faqData?.contentarticle?.results[0]?.description?.content[0]?.content[0]?.text;
  const accordions = faqData?.faqs?.results;

  return {
    title,
    description,
    accordions,
  }
}


export function processSignupData(data) {
  const aepSingupData = data?.data?.aepuseraccount;
  const backgroundimage = aepSingupData?.desktopbackgroundimage?.results?.[0].fileUrl
  const mobileBgImage = aepSingupData?.mobilebackgroundimage?.results?.[0].fileUrl
  const formfooter = aepSingupData?.formfooter?.content?.[0].content?.[0].text
  const logo = aepSingupData?.logo?.results?.[0].fileUrl
  const form = aepSingupData?.form?.results[0]
  const formTitle = form?.title
  const formDesc = form?.description?.content?.[0].content?.[0].text
  const formFields = form?.fields?.results
  const formButton = form?.buttons?.results[0]
  const logoLink = aepSingupData?.hyperlink;

  return {
    backgroundimage,
    mobileBgImage,
    formTitle,
    formDesc,
    formFields,
    formfooter,
    logo,
    formButton,
    logoLink
  };
}

export function processLoginData({data}) {
  const aepLoginData = data?.data?.aepuseraccount;
  const backgroundimage = aepLoginData?.desktopbackgroundimage?.results?.[0]?.fileUrl
  const mobileBgImage = aepLoginData?.mobilebackgroundimage?.results?.[0]?.fileUrl
  const formfooter = aepLoginData?.formfooter?.content?.[0]?.content?.[0]?.text
  const logo = aepLoginData?.logo?.results?.[0]?.fileUrl
  const form = aepLoginData?.form?.results[0]
  const formTitle = form?.title
  const formDesc = form?.description?.content?.[0]?.content?.[0]?.text
  const formFields = form?.fields?.results
 const formButton = form?.buttons?.results[0]
 const logoLink = aepLoginData?.hyperlink;

  return {
    backgroundimage,
    mobileBgImage,
    formTitle,
    formDesc,
    formFields,
    formfooter,
    logo,
    formButton,
    logoLink
  };
}

export function processOtpData(data) {
  const aepSingupData = data?.data?.data?.aepuseraccount;
  const logo = aepSingupData?.logo?.results?.[0].fileUrl
  const backgroundimage = aepSingupData?.desktopbackgroundimage?.results?.[0].fileUrl
  const form = aepSingupData?.form?.results[0]
  const formTitle = form?.title
  const formDesc = form?.description?.content?.[0].content?.[0].text
  const formFields = form?.fields?.results
  const formfooter = aepSingupData?.formfooter?.content?.[0].content?.[0].text
  const formButton = form?.buttons?.results[0];
  const logoLink = aepSingupData?.hyperlink;

  return {
    backgroundimage,
    formTitle,
    formDesc,
    formFields,
    formfooter,
    logo,
    formButton,
    logoLink
  };
}

export function processForgotPasswordData(data) {
  const aepForgotPwdData = data?.data?.aepuseraccount;
  const logo = aepForgotPwdData?.logo?.results[0]?.fileUrl
  const backgroundimage = aepForgotPwdData?.desktopbackgroundimage?.results[0]?.fileUrl
  const form = aepForgotPwdData?.form?.results[0]
  const formTitle = form?.title
  const formDesc = form?.description?.content[0]?.content[0]?.text
  const formFields = form?.fields?.results
  const formfooter = aepForgotPwdData?.formfooter?.content[0]?.content[0]?.text
  const formButton = form?.buttons?.results[0];
  const logoLink = aepForgotPwdData?.hyperlink;

  return {
    backgroundimage,
    formTitle,
    formDesc,
    formFields,
    formfooter,
    logo,
    formButton,
    logoLink
  };
}

export function processChangePasswordData(data) {
  const aepSingupData = data?.data?.aepuseraccount;
  const logo = aepSingupData?.logo?.results?.[0].fileUrl
  const backgroundimage = aepSingupData?.desktopbackgroundimage?.results?.[0].fileUrl
  const form = aepSingupData?.form?.results[0]
  const formTitle = form?.title
  const formDesc = form?.description?.content?.[0].content?.[0].text
  const formFields = form?.fields?.results
  const formfooter = aepSingupData?.formfooter?.content?.[0].content?.[0].text
  const formButton = form?.buttons?.results[0];
  const logoLink = aepSingupData?.hyperlink;

  return {
    backgroundimage,
    formTitle,
    formDesc,
    formFields,
    formfooter,
    logo,
    formButton,
    logoLink
  };
}

export function processSetPasswordData(data) {
  const aepSingupData = data?.data?.aepuseraccount;
  const logo = aepSingupData?.logo?.results?.[0].fileUrl
  const backgroundimage = aepSingupData?.desktopbackgroundimage?.results?.[0].fileUrl
  const form = aepSingupData?.form?.results[0]
  const formTitle = form?.title
  const formDesc = form?.description?.content?.[0].content[0]?.text
  const formFields = form?.fields?.results
  const formfooter = aepSingupData?.formfooter?.content?.[0].content[0]?.text
  const formButton = form?.buttons?.results[0];
  const logoLink = aepSingupData?.hyperlink;

  return {
    backgroundimage,
    formTitle,
    formDesc,
    formFields,
    formfooter,
    logo,
    formButton,
    logoLink
  };
}

